export default {  
  title: 'Panel de Control EMP',  
  loginPageName: 'Iniciar sesión',
  logoutTip: '¿Seguro que quieres cerrar sesión?',  
  submitText: 'Enviar',  
  cancelText: 'Cancelar',  
  search: 'Ingresa el contenido que quieres buscar',  
  menuTip: 'No se encontró el menú',  
  common: {  
    condition: 'Condición',  
    display: 'Mostrar',  
    hide: 'Ocultar',  
  },  
  tip: {  
    select: 'Por favor, seleccione',  
    input: 'Por favor, ingresa',  
  },  
  upload: {  
    upload: 'Haga clic para subir',  
    tip: 'Arrastra el archivo aquí, o',  
  },  
  date: {  
    start: 'Fecha de Inicio',  
    end: 'Fecha de Finalización',  
    t: 'Hoy',  
    y: 'Ayer',  
    n: 'Últimos 7 Días',  
    a: 'Todos',  
  },  
  form: {  
    printBtn: 'Imprimir',  
    mockBtn: 'Simulación',  
    submitBtn: 'Enviar',  
    emptyBtn: 'Vaciar Todos',  
  },  
  crud: {  
    filter: {  
      addBtn: 'Agregar Condición',  
      clearBtn: 'Borrar Datos',  
      resetBtn: 'Restablecer Condición',  
      cancelBtn: 'Cancelar',  
      submitBtn: 'Enviar',  
    },  
    column: {  
      name: 'Nombre de Columna',  
      hide: 'Ocultar',  
      fixed: 'Fijo',  
      filters: 'Filtros',  
      sortable: 'Ordenable',  
      index: 'Índice',  
      width: 'Ancho',  
    },  
    tipStartTitle: 'Esta tabla selecciona',  
    tipEndTitle: 'ítems',  
    editTitle: 'Editar',  
    copyTitle: 'Copiar',  
    addTitle: 'Agregar',  
    viewTitle: 'Ver',  
    filterTitle: 'Filtrar Condiciones',  
    showTitle: 'Mostrar/Ocultar Columnas',  
    menu: 'Acciones',  
    addBtn: 'Agregar',  
    show: 'Mostrar',  
    hide: 'Ocultar',  
    open: 'Abrir',  
    shrink: 'Reducir',  
    printBtn: 'Imprimir',  
    excelBtn: 'Exportar',  
    updateBtn: 'Actualizar',  
    cancelBtn: 'Cancelar',  
    searchBtn: 'Buscar',  
    emptyBtn: 'Vaciar Todos',  
    menuBtn: 'Funciones',  
    saveBtn: 'Guardar',  
    viewBtn: 'Ver',  
    editBtn: 'Editar',  
    copyBtn: 'Copiar',  
    delBtn: 'Eliminar',  
  },  
  login: {  
    loginHeader: 'Iniciar sesión',
    loginAcc: 'Cuenta',
    loginAcctx: 'Por favor, ingrese el nombre de la cuenta',
    loginPass: 'Contraseña',
    loginPasstx: 'Por favor, ingrese la contraseña',
    loginCode: 'Por favor, ingrese el código de verificación',
    loginCodetx: 'Por favor, ingrese el código de verificación',
    loginButton: 'Iniciar sesión',
    loginWait: 'Iniciando sesión, por favor espere',
    ces: 'CSE',
    emp: 'EMP',
    basicLoding: 'Cargando sistema',
    basictxLoading: 'Cargando sistema CSE EMP',
    title: 'Inicio de Sesión',  
    account: 'Cuenta',
    haveAccount: '¿Aún no tienes una cuenta?',  
    info: 'Plataforma de Desarrollo de Organizaciones de Alto Nivel BladeX',  
    tenantId: 'Inquilino',  
    username: 'Nombre de Usuario',  
    password: 'Contraseña',  
    wechat: 'WeChat',  
    qq: 'QQ',  
    github: 'GitHub',  
    gitee: 'Gitee',  
    phone: 'Ingresa tu número de teléfono',  
    code: 'Ingresa el código de verificación',  
    submit: 'Iniciar Sesión',  
    register: 'Registrarse',  
    userLogin: 'Iniciar sesión con nombre de usuario y contraseña',  
    phoneLogin: 'Iniciar sesión con teléfono',  
    thirdLogin: 'Iniciar sesión con servicios de terceros',  
    ssoLogin: 'Inicio de Sesión SSO',  
    msgText: 'Enviando código de verificación',  
    msgSuccess: 'El código de verificación ha sido enviado',  
  },  
  navbar: {  
    info: 'información',
    logOut: 'Cerrar Sesión',  
    userinfo: 'Información del Usuario',  
    switchDept: 'Cambiar Departamento',  
    dashboard: 'Panel de Control',  
    lock: 'Bloquear Pantalla',  
    bug: 'No hay errores',  
    bugs: 'Errores',  
    screenfullF: 'Salir de Pantalla Completa',  
    screenfull: 'Pantalla Completa',  
    language: 'Idioma',  
    notice: 'Notificaciones',  
    theme: 'Tema',  
    color: 'Cambiar Color',  
  },  
  tagsView: {  
    search: 'Buscar',  
    menu: 'Más',  
    clearCache: 'Borrar Caché',  
    closeOthers: 'Cerrar Otros',  
    closeAll: 'Cerrar Todos',  
  },
  mBtn: {
    addSub: 'add a sub-item',
    dictConfig: 'Dict Config'
  },
  theader: {
    measuringPoint: 'punto de medición',
    name: 'nombre',
    realTimeValue: 'valor en tiempo real',
    unit: 'unidad',
    updateTime: 'Hora de actualización',
    storage: 'Almacenamiento (minutos)',
    alerts: 'Alarma',
    operate: 'funcionar',
    project: 'proyecto',
    area: 'área',
    detailAddress: 'Dirección detallada',
    protocol: 'protocolo',
    correspondenceAddress: 'Dirección de correspondencia',
    dataTimeout: 'Tiempo de espera de datos (minutos)',
    serialNumber: 'número de serie',
    deviceId: 'ID del dispositivo',
    gatewayId: 'ID de puerta de enlace',
    gatewayName: 'Nombre de la puerta de enlace',
    serialPortAddress: 'Dirección del puerto serie',
    modelId: 'ID del modelo',
    creationTime: 'tiempo de creación',
    updater: 'Actualizador',
    dataEncoding: 'Codificación de datos',
    fourShakeAttributes: 'Cuatro atributos de batido',
    storage: 'Almacenamiento (minutos)',
    storageClass: 'clase de almacenamiento',
    alarmTime: 'hora de alarma',
    recoveryTime: 'tiempo de recuperación',
    alarmLevel: 'Nivel de alarma',
    alarmContent: 'Contenido de la alarma',
    reportName: 'Nombre del informe',
    reportTime: 'Hora del informe',
    equipmentFailureRate: 'Tasa de falla del equipo',
    score: 'puntaje',
    healthStatus: 'estado de salud',
    roleName: 'Nombre del personaje',
    tenants: 'Inquilino propio',
    roleAliaes: 'alias de rol',
    roleSorting: 'Clasificación de roles',
    institutionName: 'Nombre de la organización',
    fullNameOfOrganization: 'Nombre completo de la organización',
    institutionType: 'Tipo de institución',
    sorting: 'clasificar',
    loginAccount: 'Iniciar sesión en la cuenta',
    userName: 'Nombre de usuario',
    role: 'Role',
    department: 'Departamento',
    userPlatform: 'Plataforma de usuario',
    potitionType: 'Tipo de posición',
    positionNo: 'Número de posición',
    potitionTitle: 'Título profesional',
    potitionSorting: 'Clasificación de posición',
    dictionaryNumber: 'número de diccionario',
    dictionaryName: 'Nombre del diccionario',
    dictionarySorting: 'Ordenar diccionario',
    archive: 'Sello',
    menuName: 'Nombre del menú',
    rutingAddress: 'dirección de ruta',
    menuIcon: 'icono de menú',
    menuAliases: 'Alias de menú',
    menuNo: 'Número de menú',
    menuSorting: 'Clasificación de menú',
    tenantId: 'ID de inquilino',
    tenantName: 'Nombre del inquilino',
    contact: 'Persona de contacto',
    contactNumber: 'Número de contacto',
    accountLimit: 'Límite de cuenta',
    expirationTime: 'tiempo de vencimiento',
    bindDomainName: 'Vincular nombre de dominio',
    projectArea: 'Área del proyecto',
    reportAttributes: 'Cuatro propiedades de informes',
    description: 'describir',
    caculateFactor: 'factor de cálculo',
    dataInfo: 'Información de datos',
  }
};
